import {NgModule} from "@angular/core";
import {SharedModule} from "../shared/shared.module";
import {MembershipTypeSearchPageComponent} from "./membership-type/membership-type-search-page/membership-type-search-page.component";
import {MemberSearchPageComponent} from "./member/member-search-page/member-search-page.component";
import {MembershipTypeMultiSelectSearchControlComponent} from "./membership-type/controls/membership-type-multi-select-search-control.component";
import {MarketingCampaignSearchPageComponent} from "./marketing-campaign/marketing-campaign-search-page/marketing-campaign-search-page.component";
import {FrameworkModule} from "../framework/framework.module";
import {ContactSharedModule} from "../contact/contact.shared.module";
import {MemberEditPageComponent} from "./member/member-edit-page/member-edit-page.component";
import {MemberEditDetailsComponent} from "./member/member-edit-page/member-edit-details/member-edit-details.component";
import {MemberEditPricingComponent} from "./member/member-edit-page/member-edit-pricing/member-edit-pricing.component";
import {MemberEditRenewalComponent} from "./member/member-edit-page/member-edit-renewal/member-edit-renewal.component";
import {CustomersSharedModule} from "./customers.shared.module";
import {AccountSharedModule} from "../accounts/account.shared.module";
import {PricingSharedModule} from "../pricing/pricing.shared.module";
import {PosSharedModule} from "../pos/pos.shared.module";
import {AddressSharedModule} from "../address/address.shared.module";
import {MembershipTypeEditDetailsComponent} from "./membership-type/membership-type-edit-page/membership-type-edit-details/membership-type-edit-details.component";
import {MembershipTypeEditPageComponent} from "./membership-type/membership-type-edit-page/membership-type-edit-page.component";
import {MembershipTypeEditCustomObjectsComponent} from "./membership-type/membership-type-edit-page/membership-type-edit-custom-objects/membership-type-edit-custom-objects.component";
import {SystemSharedModule} from "../system/system.shared.module";
import {CustomObjectSharedModule} from "../custom-objects/custom-object.shared.module";
import {MemberLoyaltySignupReportComponent} from "./reports/member-loyalty-signup-report/member-loyalty-signup-report.component";
import {EmployeeSharedModule} from "../employee/employee.shared.module";
import {MemberDetailsReportComponent} from "./reports/member-details-report/member-details-report.component";
import {MemberLoyaltyReportComponent} from "./reports/member-loyalty-report/member-loyalty-report.component";
import {CatalogueSharedModule} from "../catalogue/catalogue.shared.module";
import {ReportsSharedModule} from "../reports/reports.shared.module";
import {LoyaltyCardSearchPageComponent} from "./loyalty-card/loyalty-card-search-page/loyalty-card-search-page.component";
import {LoyaltyCardEditPageComponent} from "./loyalty-card/loyalty-card-edit-page/loyalty-card-edit-page.component";
import {OptInMarketingSearchPageComponent} from "./opt-in-marketing/opt-in-marketing-search-page/opt-in-marketing-search-page.component";


@NgModule({
    imports: [
        SharedModule,
        FrameworkModule,
        ReportsSharedModule,
        CustomObjectSharedModule,
        ContactSharedModule,
        CustomersSharedModule,
        AccountSharedModule,
        PricingSharedModule,
        PosSharedModule,
        AddressSharedModule,
        SystemSharedModule,
        EmployeeSharedModule,
        CatalogueSharedModule
    ],
    declarations: [
        MembershipTypeSearchPageComponent,
        MemberSearchPageComponent,
        MembershipTypeMultiSelectSearchControlComponent,
        MarketingCampaignSearchPageComponent,
        MemberEditPageComponent,
        MemberEditDetailsComponent,
        MemberEditPricingComponent,
        MemberEditRenewalComponent,
        MembershipTypeEditDetailsComponent,
        MembershipTypeEditPageComponent,
        MembershipTypeEditCustomObjectsComponent,
        MemberLoyaltySignupReportComponent,
        MemberDetailsReportComponent,
        MemberLoyaltyReportComponent,
        LoyaltyCardSearchPageComponent,
        LoyaltyCardEditPageComponent,
        OptInMarketingSearchPageComponent
    ],
    exports: [
        MembershipTypeSearchPageComponent,
        MemberSearchPageComponent,
        MembershipTypeMultiSelectSearchControlComponent,
        MarketingCampaignSearchPageComponent,
        MemberEditPageComponent,
        MemberEditDetailsComponent,
        MemberEditPricingComponent,
        MemberEditRenewalComponent,
        MembershipTypeEditDetailsComponent,
        MembershipTypeEditPageComponent,
        MembershipTypeEditCustomObjectsComponent,
        MemberLoyaltySignupReportComponent,
        MemberDetailsReportComponent,
        MemberLoyaltyReportComponent,
        LoyaltyCardSearchPageComponent,
        LoyaltyCardEditPageComponent,
        OptInMarketingSearchPageComponent
    ]
})
export class CustomersModule {
}
